const ADMIN_API = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:8080/api/admin';

export function getAdminToken() {
  return sessionStorage.getItem('admin_token');
}

export function setAdminToken(token) {
  sessionStorage.setItem('admin_token', token);
}

export function clearAdminToken() {
  sessionStorage.removeItem('admin_token');
}

export function isAdminAuthenticated() {
  return Boolean(getAdminToken());
}

async function adminFetch(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const token = getAdminToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  let response;
  try {
    response = await fetch(`${ADMIN_API}${path}`, {
      ...options,
      headers,
    });
  } catch (error) {
    throw new Error('Cannot reach API. Start PHP: C:\\xampp\\php\\php.exe -S localhost:8080 -t public');
  }

  const data = await response.json().catch(() => ({}));

  if (response.status === 401) {
    clearAdminToken();
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.error || `Request failed (${response.status})`);
  }

  return data;
}

export async function adminLogin(email, password) {
  const data = await adminFetch('/login.php', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  setAdminToken(data.token);
  return data;
}

export function adminLogout() {
  clearAdminToken();
}

export async function fetchAdminBlogs() {
  return adminFetch('/blogs.php');
}

export async function fetchAdminBlog(id) {
  return adminFetch(`/blogs.php?id=${id}`);
}

export async function createBlog(blog) {
  return adminFetch('/blogs.php', {
    method: 'POST',
    body: JSON.stringify(blog),
  });
}

export async function updateBlog(id, blog) {
  return adminFetch(`/blogs.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify(blog),
  });
}

export async function deleteBlog(id) {
  return adminFetch(`/blogs.php?id=${id}`, {
    method: 'DELETE',
  });
}

export async function fetchAdminContacts() {
  return adminFetch('/contacts.php');
}

export async function uploadBlogImage(file) {
  const token = getAdminToken();
  const formData = new FormData();
  formData.append('image', file);

  let response;
  try {
    response = await fetch(`${ADMIN_API}/upload.php`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });
  } catch (error) {
    throw new Error('Cannot reach API. Start PHP: C:\\xampp\\php\\php.exe -S localhost:8080 -t public');
  }

  const data = await response.json().catch(() => ({}));

  if (response.status === 401) {
    clearAdminToken();
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.error || `Upload failed (${response.status})`);
  }

  return data;
}
